export default "__VITE_ASSET__pBbfhsNi__"